// Material Dashboard 2 PRO React — dark theme override for MuiPaper.
// themeDark doesn't set palette.mode: "dark", so MUI's default Paper renders
// with the light-mode background (white). Cards already override their own
// backgrounds via the Card component styles, and Dialogs are handled by the
// MuiDialog.paper override. This catches the remaining cases — bare
// <Paper> usages (search-form wrappers, panels, etc.) — and disables the
// elevation-gradient backgroundImage that lightens the surface.

import colors from "assets/theme-dark/base/colors";

const { background, text } = colors;

const paper = {
  styleOverrides: {
    root: {
      backgroundColor: background.card,
      color: text.main,
      backgroundImage: "none",
    },
  },
};

export default paper;
